import { create } from '@bufbuild/protobuf'
import { useQuery } from '@connectrpc/connect-query'
import { getJepxMemberInfo } from '@ebalance/proto/bffuser/v1/jepx_member_info_service-JepxMemberInfoService_connectquery'
import { GetJepxMemberInfoRequestSchema } from '@ebalance/proto/bffuser/v1/jepx_member_info_service_pb'
import { useTranslation } from 'react-i18next'

import { Box } from '@enechain/ecloud-designsystem'

import { CompactAlert } from '~/components/common/CompactAlert'

/** AC-IJM-013: a failed or pending request is not evidence of missing registration. */
export function useJepxMemberBidWarning(): string | undefined {
  const { t } = useTranslation()
  const { data, isSuccess } = useQuery(
    getJepxMemberInfo,
    create(GetJepxMemberInfoRequestSchema, {}),
    { throwOnError: false },
  )
  // 未解決・取得失敗は「未登録」の根拠ではないため、既存の操作を止めない。
  if (!isSuccess) return undefined
  return data?.memberInfo === undefined
    ? t('page:jepxMemberBidWarning.title')
    : undefined
}

export const JepxMemberBidWarning = ({
  reason,
}: {
  reason: string
}): React.ReactElement => {
  const { t } = useTranslation()
  // 入札の入口を止める状態の通知。見出し + 説明の Compact (UI 辞書 alert-placement.md §0)
  return (
    <Box flexShrink={0} data-testid="jepx-member-bid-warning">
      <CompactAlert
        description={t('page:jepxMemberBidWarning.body')}
        status="warning"
        title={reason}
      />
    </Box>
  )
}
